// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

const regenerate = wrapWithNetworkError(function regenerateToken(
  token: string,
  clientId?: number
) {
  const fetchUrl =
    getEndpointUrl('/regenerate') +
    (typeof clientId === 'number' ? `?merchantGroupId=${clientId}` : '');
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
  };

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => response.json());
});

export default regenerate;



// WEBPACK FOOTER //
// ./src/api/auth/regenerate.js